// @ts-nocheck

import CarryOutOutlined from '@ant-design/icons/CarryOutOutlined';
import CalculatorOutlined from '@ant-design/icons/CalculatorOutlined';
import IdcardOutlined from '@ant-design/icons/IdcardOutlined';
import MediumOutlined from '@ant-design/icons/MediumOutlined';
import SwitcherOutlined from '@ant-design/icons/SwitcherOutlined';
import CodeOutlined from '@ant-design/icons/CodeOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import FormOutlined from '@ant-design/icons/FormOutlined';
import DiffOutlined from '@ant-design/icons/DiffOutlined';
import ScheduleOutlined from '@ant-design/icons/ScheduleOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import AreaChartOutlined from '@ant-design/icons/AreaChartOutlined';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import BarsOutlined from '@ant-design/icons/BarsOutlined';
import CreditCardOutlined from '@ant-design/icons/CreditCardOutlined';
import PayCircleOutlined from '@ant-design/icons/PayCircleOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import AimOutlined from '@ant-design/icons/AimOutlined'

export default {
  CarryOutOutlined,
CalculatorOutlined,
IdcardOutlined,
MediumOutlined,
SwitcherOutlined,
CodeOutlined,
DollarOutlined,
FormOutlined,
DiffOutlined,
ScheduleOutlined,
BarChartOutlined,
AreaChartOutlined,
LineChartOutlined,
BarsOutlined,
CreditCardOutlined,
PayCircleOutlined,
SettingOutlined,
FileTextOutlined,
AimOutlined
}
    